import { Component, inject, ChangeDetectorRef } from '@angular/core';

import { MessageService } from '../message.service';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss'],
    standalone: false
})
export class MessagesComponent {
  messageService = inject(MessageService);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    // Trigger change detection when messages update
    this.messageService.onMessageChange = () => {
      this.cdr.detectChanges();
    };
  }
}
